import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import HtmlContent from './HtmlContent';
import { formatDuracionClase } from '../utils/duration';
import './CardCurso.css';

const CardCurso = ({ curso }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const isAuthenticated = authService.isAuthenticated();

  const cantidadClases = curso.cantidad_clases != null ? Number(curso.cantidad_clases) : null;
  const duracionHoras = curso.duracion_horas != null ? Number(curso.duracion_horas) : null;
  const duracionClaseLabel = formatDuracionClase(curso.duracion_clase);
  const durationLabel =
    cantidadClases != null && cantidadClases > 0 && duracionHoras != null && duracionHoras > 0
      ? `${cantidadClases} clases (${duracionHoras} horas)`
      : duracionHoras
      ? `${duracionHoras} horas`
      : duracionClaseLabel
      ? `${duracionClaseLabel} por clase`
      : null;
  const equipoNombresSolo =
    Array.isArray(curso.equipo) && curso.equipo.length > 0
      ? curso.equipo.map((e) => (e && e.nombre ? e.nombre : '')).filter(Boolean)
      : Array.isArray(curso.equipo_nombres) && curso.equipo_nombres.length > 0
      ? curso.equipo_nombres.map((s) => (typeof s === 'string' ? s.replace(/\s*\([^)]*\)\s*$/, '').trim() : '')).filter(Boolean)
      : [];
  const equipoTexto = equipoNombresSolo.length > 0 ? equipoNombresSolo.join(', ') : null;
  const inscripcionAbierta = curso.inscripcion_abierta === true;
  const inscripcionDisponiblePorCodigo = curso.inscripcion_disponible_por_codigo === true || (curso.inscripcion_disponible_por_codigo == null && inscripcionAbierta);
  const sinCupos = curso.cupo_maximo > 0 && (curso.cupo_actual ?? 0) >= curso.cupo_maximo;
  const puedeInscribirse = inscripcionDisponiblePorCodigo && !(inscripcionAbierta && sinCupos);
  const labelInscripcion = inscripcionDisponiblePorCodigo ? (inscripcionAbierta && sinCupos ? 'Sin cupos' : 'Inscribirme') : 'Próximamente';

  const handleVerMas = (e) => {
    e.preventDefault();
    setShowInfo(true);
  };

  const handleInscripcion = (e) => {
    e.preventDefault();
    if (!puedeInscribirse) return; // Fuera de fecha o sin cupos: no hacer nada
    if (!isAuthenticated) {
      setShowPopup(true);
      return;
    }
    navigate('/dashboard/cursos-disponibles');
  };

  const nivelNombre = curso.nivel_nombre || (curso.nivel && typeof curso.nivel === 'object' && curso.nivel.nombre ? curso.nivel.nombre : null);

  return (
    <>
      <div className="card-curso">
        {nivelNombre && (
          <span className="card-curso-badge-nivel" aria-label={`Nivel: ${nivelNombre}`}>
            {nivelNombre}
          </span>
        )}
        <div className="card-curso-icon">📚</div>
        <h3 className="card-curso-title" onClick={handleVerMas}>
          {curso.nombre}
        </h3>
        {curso.descripcion && (
          <HtmlContent content={curso.descripcion} tag="p" className="card-curso-desc" />
        )}
        {(cantidadClases != null && cantidadClases > 0) && (
          <p className="card-curso-clases">{cantidadClases} {cantidadClases === 1 ? 'clase' : 'clases'}</p>
        )}
        <div className="card-curso-buttons">
          <button type="button" className="card-curso-vermas" onClick={handleVerMas}>
            Ver más
          </button>
          <button
            type="button"
            className="card-curso-inscribirme"
            onClick={handleInscripcion}
            disabled={!puedeInscribirse}
            title={!inscripcionDisponiblePorCodigo ? 'La inscripción aún no está abierta o ya finalizó' : inscripcionAbierta && sinCupos ? 'No hay cupos disponibles' : undefined}
          >
            {labelInscripcion}
          </button>
        </div>
      </div>

      {/* Modal Ver más */}
      {showInfo && (
        <div className="card-curso-overlay" onClick={() => setShowInfo(false)}>
          <div className="card-curso-modal" onClick={(e) => e.stopPropagation()}>
            <div className="card-curso-modal-header">
              <span className="card-curso-modal-icon">📚</span>
              <h2>{curso.nombre}</h2>
            </div>
            <div className="card-curso-modal-body">
              {curso.descripcion && <HtmlContent content={curso.descripcion} tag="p" className="card-curso-modal-desc" />}
              {durationLabel && (
                <p><strong>Duración:</strong> {durationLabel}</p>
              )}
              {equipoTexto && (
                <p><strong>Equipo:</strong> {equipoTexto}</p>
              )}
            </div>
            <div className="card-curso-modal-actions">
              <button type="button" className="card-curso-btn-cerrar" onClick={() => setShowInfo(false)}>
                Cerrar
              </button>
              <button
                type="button"
                className="card-curso-btn-inscribir"
                onClick={handleInscripcion}
                disabled={!puedeInscribirse}
                title={!inscripcionDisponiblePorCodigo ? 'La inscripción aún no está abierta o ya finalizó' : inscripcionAbierta && sinCupos ? 'No hay cupos disponibles' : undefined}
              >
                {labelInscripcion}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popup login/register */}
      {showPopup && (
        <div className="card-curso-overlay" onClick={() => setShowPopup(false)}>
          <div className="card-curso-popup" onClick={(e) => e.stopPropagation()}>
            <h3>¿Querés participar?</h3>
            <p>Registrate o iniciá sesión para inscribirte en el curso.</p>
            <div className="card-curso-popup-btns">
              <button type="button" onClick={() => { setShowPopup(false); navigate('/login'); }}>
                Iniciar sesión
              </button>
              <button type="button" className="card-curso-popup-register" onClick={() => { setShowPopup(false); navigate('/register'); }}>
                Registrarse
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardCurso;
